import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import api from "../../../../api";

class TopSurveysRankDeleteButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      deleting: false
    }
  }

  delete(){
    this.setState({
      deleting: true
    });

    api.topSurveysRank.delete(this.props.id).then(() => {
      this.setState({deleting: false, modal: false});
      this.props.handleChange();
    }).catch(() => {
      this.setState({
        deleting: false
      });
    });
  }

  toggleModalDelete(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { deleting } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModalDelete()}>
      <ModalHeader toggle={() => this.toggleModalDelete()} tag="h2">Usuń wpis</ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <p>Czy na pewno chcesz usunąć wpis?</p>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.modal.delete.confirmation">{
          (message) => <LaddaButton
            className="btn btn-danger btn-ladda"
            loading={deleting}
            data-style={ZOOM_OUT}
            onClick={() => this.delete()}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModalDelete()}>{message}</Button>
        }</FormattedMessage>

      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <FormattedMessage id="_.button.delete">{
          (message) =>
            <Button color="danger" size="sm" onClick={() => this.toggleModalDelete()}><i className="fas fa-times" /> {message}</Button>
        }</FormattedMessage>
        {modal}
      </React.Fragment>
    )
  }
}

TopSurveysRankDeleteButton.propTypes = {
  id: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default TopSurveysRankDeleteButton;